import { MaterialUICore, Alert } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const AlertDS = styled(Alert)(() => ({
  height: '100% !important',
}));
